<app-top-nav-registration></app-top-nav-registration>
<div class="overlay sgp-intro-color">
<div class="container ">
    <div class="content">
        <div class="bb-sgp-intro-panel sgp-intro-color">
            <div>
                <div class="h-30"></div>
                <h3>{{ 'sgpIntroHeading' | translate:translations }}</h3>
                <h4>{{ 'sgpIntroSubheading' | translate:translations }}</h4>

                <div class="h-30"></div>
                <span class="bb-self-guided-intro-desc">
                    {{ 'sgpIntroBody' | translate:translations }}
                </span>

                <div class="h-30"></div>
                <span>
                    <strong>{{ 'sgpIntroCbtNote' | translate:translations }}</strong>
                </span>

                <div class="h-30"></div>
                <div class="form-buttons">
                    <a href="/bb-login" class="submit-form-button">{{ 'sgpIntroSignIn' | translate:translations }}</a>
                    <a href="/register-bb-self-guided-first-step" class="delete-button transparent">{{ 'sgpIntroRegister' | translate:translations }}</a>
                </div>
            </div>
            <div class="intro-image">
                <img src="assets/sgp-intro-photo.png">
            </div>
        </div>

    </div>
</div>
</div>
<div class="container">
    <div class="partners">
        <div class="h-30"></div>
    {{ 'sgpIntroPartners' | translate:translations }}
    <div class="mb-10"></div>
    <img src="assets/cmha-logo.png" height="65px">
    <img src="assets/phsa-logo.png" height="65px">
    <img src="assets/wrha-logo.png" height="65px">
    <img src="assets/winnipeg-foundation.png" height="65px">
</div>
</div>
<app-footer></app-footer>
